import { Flex } from 'components/Flex';
import styled, { css } from 'styled-components';

export const ShiftsCalendarListByDayModalShiftCardWrapper = styled.div`
  position: relative;
  padding: 12px;
  width: 100%;
  min-height: 110px;
  background-color: ${({ theme }) => theme.colors.White};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  &:first-child {
    margin-top: 20px;
  }
  ${({ theme }) => css`
    ${theme.borders.DefaultBorder};
    ${theme.shadows.Default};
  `}
`;

export const AvatarIconWrapper = styled.div`
  position: relative;
`;

export const ModalDatePickerWrapper = styled.div`
  height: 52px;
`;

export const ShiftID = styled.div`
  ${({ theme }) => theme.typography.Body}
  font-size:14px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-weight: 500;
  margin-top: 8px;
`;

export const ShiftSectionA = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 32px;
`;

export const ShiftLink = styled.div`
  ${({ theme }) => theme.typography.TextLink};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
`;

export const ShiftDate = styled.div<{ noMargin?: boolean }>`
  ${({ theme }) => theme.typography.Body}
  font-size:14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 325px;
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '8px')};
`;
export const PendingSignUpText = styled.div`
  ${({ theme }) => theme.typography.Body}
  font-size: 16px;
  color: ${({ theme }) => theme.colors.Grey6};
  line-height: 24px;
`;

export const PositionText = styled.div`
  ${({ theme }) => theme.typography.Body}
  font-size: 14px;
  color: ${({ theme }) => theme.colors.TextHighlight2};
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const EmptyStatement = styled.div`
  ${({ theme }) => theme.typography.Body}
  margin-bottom: 24px;
`;

export const FilterWrapper = styled.div``;

export const FilterText = styled.div`
  ${({ theme }) => theme.typography.Body}
`;

export const FilterButton = styled.button`
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledFlex = styled(Flex)`
  margin: 20px;
`;
